export { Favicon } from "~/components/web/ui/favicon"
